import { Layout } from "@layouts";
import { Item, airdropConfirmationColumns, PageBreadcrumbs } from "@molecules";
import { DataTable } from "@organisms";
import { Button as SButton, Progress } from "@shadcn";
import { CurrencyTypes, PremiumGiftCardAirdropRequest } from "@api";
import { useNavigate } from "react-router";
import { useContext } from "react";
import { AuthContext } from "@auth";
import { PagePaths, AirdropPagePaths } from "../../../../types";
import { useTranslation } from "react-i18next";

export type AirdropCompletePageTemplateProps = {
  progress: number;
  airdropGiftCard: (
    airdropGiftCardRequest: PremiumGiftCardAirdropRequest,
    paymentId: string,
  ) => Promise<void>;
};

export const AirdropCompletePageTemplate = ({
  progress,
  airdropGiftCard,
}: AirdropCompletePageTemplateProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setSelectedPageIndex } = useContext(AuthContext);
  const goToPerks = () => {
    setSelectedPageIndex?.(3);
    navigate(`/dashboard/${PagePaths.perks}`);
  };
  const goToAirdrops = () => {
    setSelectedPageIndex?.(3);
    navigate(`/dashboard/${PagePaths.airdrop}/main`);
  };
  const goToSelectMembers = () => {
    setSelectedPageIndex?.(3);
    navigate(`/dashboard/${PagePaths.airdrop}/${AirdropPagePaths.selectMembers}`);
  };
  const goToSelectGiftCard = () => {
    setSelectedPageIndex?.(3);
    navigate(`/dashboard/${PagePaths.airdrop}/${AirdropPagePaths.selectOffers}`);
  };
  const goToSelectAmount = () => {
    setSelectedPageIndex?.(3);
    navigate(`/dashboard/${PagePaths.airdrop}/${AirdropPagePaths.selectAmount}`);
  };
  const goToConfirm = () => {
    setSelectedPageIndex?.(3);
    navigate(`/dashboard/${PagePaths.airdrop}/confirm`);
  };

  const onReturnToAirdropPage = () => {
    const to = "/dashboard/airdrop/select-members";
    navigate(to);
  }

  const onReturnToHomePage = () => {
    const to = "/dashboard/home";
    navigate(to);
  }

  return (
    <Layout
      variant="dashboard"
      header={t("airdrop.common.header")}
      subheader={
        <div className="flex flex-row items-start justify-between max-w-5xl">
          <div className="page-subtitle mt-2">
            {t("airdrop.common.subheader")}
          </div>
        </div>
      }
    >
      <div className="p-1 mr-4 rounded-md max-w-3xl">
        <PageBreadcrumbs
          items={[
            { label: t("airdrop.common.breadcrumbs.benefits"), onClick: goToPerks },
            { label: t("airdrop.common.breadcrumbs.airdrops"), onClick: goToAirdrops },
            { label: t("airdrop.common.breadcrumbs.selectMembers"), onClick: goToSelectMembers },
            { label: t("airdrop.common.breadcrumbs.selectGiftCard"), onClick: goToSelectGiftCard },
            { label: t("airdrop.common.breadcrumbs.selectAmount"), onClick: goToSelectAmount },
            { label: t("airdrop.common.breadcrumbs.confirm"), onClick: goToConfirm },
            { label: t("airdrop.complete.breadcrumbs.complete") },
          ]}
        />
        <div className="flex flex-col gap-6 border border-neutral-light bg-white rounded-2xl w-full min-w-[400px] p-6">
          <h2 className="text-xl font-normal">
            {t("airdrop.complete.successTitle")}
          </h2>
          <div className="flex flex-row items-center justify-start max-w-3xl">
            <SButton
              variant="default"
              onClick={onReturnToAirdropPage}
            >
              {t("airdrop.complete.sendAnother")}
            </SButton>
            <div className="w-2"></div>
            <SButton
              variant="outline"
              onClick={onReturnToHomePage}
              className="ml-2 border border-primary-medium text-primary-medium bg-white hover:bg-primary-lightest hover:text-primary-medium shadow-none"
            >
              {t("airdrop.complete.returnHome")}
            </SButton>
          </div>
        </div>
      </div>
    </Layout>
  );
};
